"use client";

import * as React from "react";
import NiceModal from "@ebay/nice-modal-react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";

import { TooltipProvider } from "@acme/ui/components/tooltip";

import { DomainHooksProvider } from "~/context/domain-hooks-context/domain-hooks-context";
import { domainHooksRegistry } from "~/context/domain-hooks-context/domain-hooks-registry";
import { TRPCReactProvider } from "~/trpc/react";
import { SidebarProvider } from "@acme/ui/components/sidebar";
import ClientErrorBoundary from "./error_boundary";
import { CopilotProvider } from "@acme/ui/components/copilot-kit";

export function Providers({
  children,
  isPreviewMode,
}: React.PropsWithChildren & { isPreviewMode: boolean }): React.JSX.Element {
  const queryClient = new QueryClient();
  return (
    <ClientErrorBoundary isPreviewMode={isPreviewMode}>
      <ThemeProvider
        attribute="class"
        defaultTheme="light"
        // enableSystem
        disableTransitionOnChange
      >
        <CopilotProvider>
          <TRPCReactProvider>
            <QueryClientProvider client={queryClient}>
              <TooltipProvider>
                <NiceModal.Provider>
                  <DomainHooksProvider registry={domainHooksRegistry}>
                    {children}
                  </DomainHooksProvider>
                </NiceModal.Provider>
              </TooltipProvider>
            </QueryClientProvider>
          </TRPCReactProvider>
        </CopilotProvider>
      </ThemeProvider >
    </ClientErrorBoundary >
  );
}
